export const AxiosLoggerRequestConfig = {
  prefixText: 'Intigral',
  headers: true,
  params: true,
};

export const AxiosLoggerResponseConfig = {
  prefixText: 'Intigral',
  data: false,
  headers: true,
  params: true,
};
